enum PackType {
  Core = 1,
  Fundamental,
  Premium,
  Starter,
}

export default PackType;
